@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
<div class="bab-option-group-renderer" msOptionGroupRenderer [optionGroup]="optionGroup" [optionPickClass]="'.option-pick > div'">
    @for (market of marketsList | slice: 0 : visibleOptionsLimit; track trackOption(position, market); let position = $index) {
        <ms-precreated-option
            [market]="market"
            [event]="event"
            [fixtureId]="fixtureId"
            [contentPosition]="position"
            [trackingModuleType]="trackingModuleType" />
    }

    @for (
        betBuilderOptionGroup of optionGroups | slice: 0 : visibleOptionsLimit;
        track trackGroup(position, betBuilderOptionGroup);
        let position = $index
    ) {
        <ms-precreated-group-option
            [optionGroup]="betBuilderOptionGroup"
            [eventOptionGroups]="eventOptionGroups"
            [event]="event"
            [showSGPButtonsInPrebuiltSGP]="showSGPButtonsInPrebuiltSGP"
            [sourceOfPick]="sourceOfPick" />
    }
    @if (showSGPButtonsInPrebuiltSGP && !hideBetBuilderButton) {
        <div class="btn-build-your-bet">
            <ms-bet-builder-button
                [event]="event"
                [hasPreCreated]="true"
                [isPrecreatedBABPod]="true"
                [source]="betbuilderTrackingValues.PreCreated"
                [buttonSource]="buttonSource"
                [betBuilderEpcotEnabled]="betBuilderEpcotEnabled" />
        </div>
    }
    @if (!isInSheetView) {
        <ms-option-panel-bottom-action
            [data]="showMoreData"
            [showMoreCounter]="showMoreCounter"
            (showMore)="onShowMore($event)"
            (showAllRequested)="showAllRequested.next()" />
    }
</div>
